import { useEffect, useState } from 'react';
import CardUangReadonly from './CardUangReadonly';
import { normalizeIjin } from '../hooks/normalizeIjin';
import { isPendingUang } from '../utils/uangApproval';
import { motion } from 'framer-motion';
import CardCarousel from './CardCarousel';

const ListUangReadonly = () => {
  const [dataKeuangan, setDataKeuangan] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = () => {
    try {
      const rawKasbon = localStorage.getItem('uang_pengajuanKasbon');
      const parsedKasbon = rawKasbon ? JSON.parse(rawKasbon) : [];

      const rawIjin = localStorage.getItem('ijin_pengajuan');
      const parsedIjin = rawIjin ? JSON.parse(rawIjin) : [];

      const combinedData = [...(Array.isArray(parsedKasbon) ? parsedKasbon : []), ...(Array.isArray(parsedIjin) ? parsedIjin : [])];

      const normalized = combinedData.map(item => {
            const baseItem = normalizeIjin(item);
            // Injeksi manual struktur API keuangan (sering ditandai dengan potongan_id)
            if (baseItem.potongan_id) {
              if (baseItem.potongan_id === 3) baseItem.absen_id = 'kasbon';
              else if (baseItem.potongan_id === 22) baseItem.absen_id = 'lembur';
              else if (baseItem.potongan_id === 11) baseItem.absen_id = 'piket_harian'; // Generic fallback piket
              else baseItem.absen_id = 'cicilan';
              
              baseItem.nama = baseItem.keperluan || baseItem.nama || '-';
            }
            return baseItem;
          });

      // Cukup simpan semuanya yang masuk kategori keuangan
      const idsKeuangan = ['kasbon', 'cicilan', 'lembur', 'piket_harian', 'piket_perconnote'];
      const combinedFiltered = normalized.filter(item =>
        idsKeuangan.includes(item.absen_id) && isPendingUang(item)
      );

      setDataKeuangan(combinedFiltered);
    } catch (e) {
      console.error('Gagal membaca localStorage uang_pengajuanKasbon', e);
    } finally {
      setLoading(false);
    }
    };

    loadData();
    window.addEventListener('storage', loadData);
    window.addEventListener('badgeUpdate', loadData);

    return () => {
      window.removeEventListener('storage', loadData);
      window.removeEventListener('badgeUpdate', loadData);
    };
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40, color: '#6b7280' }}>
        Memuat data keuangan...
      </div>
    );
  }

  if (dataKeuangan.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          backgroundColor: '#ffffff',
          borderRadius: 24,
          width: '100%',
          maxWidth: 450,
          margin: '0 auto 24px auto',
          padding: '24px 20px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
          border: '1px solid #cbd5e1',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          textAlign: 'center',
          marginBottom: 32,
          paddingBottom: 24,
          borderBottom: '1px solid #f0f0f0'
        }}>
          <h2 style={{
            fontWeight: 700,
            fontSize: 18,
            margin: '0 0 2px 0',
            color: '#111827'
          }}>
            Riwayat Keuangan
          </h2>
          <p style={{ margin: 0, color: '#9ca3af', fontSize: 13 }}>
            {dataKeuangan.length} riwayat pengajuan diproses
          </p>
        </div>
        <div style={{
          textAlign: 'center',
          padding: '40px 20px',
          background: '#f9fafb',
          borderRadius: 16,
          border: '1px dashed #e5e7eb'
        }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>💰</div>
          <p style={{ margin: 0, fontWeight: 600, color: '#4b5563', fontSize: 15 }}>
            Belum ada pengajuan
          </p>
          <p style={{ margin: '4px 0 0 0', color: '#9ca3af', fontSize: 13 }}>
            Tidak ada data riwayat pengajuan keuangan
          </p>
        </div>
      </motion.div>
    );
  }

  const renderCarousel = (title, dataList, themeColor) => {
    if (dataList.length === 0) return null;

    return (
      <div style={{ marginBottom: 32 }}>
        <div style={{
          marginBottom: 16,
          paddingBottom: 12,
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between'
        }}>
          <h3 style={{
            fontWeight: 600,
            fontSize: 18,
            margin: 0,
            color: '#1a1a1a',
          }}>
            {title}
          </h3>
          <span style={{ fontSize: 13, color: themeColor, fontWeight: 700, backgroundColor: themeColor + '15', width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' }}>
            {dataList.length}
          </span>
        </div>
        
        <CardCarousel itemStyle={{ minWidth: 300, maxWidth: 340 }}>
          {dataList.map(item => (
              <CardUangReadonly key={item.id} item={item} />
          ))}
        </CardCarousel>
      </div>
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.3 }}
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 24,
        margin: '0 auto 24px auto',
        padding: '24px 20px',
        width: '100%',
        maxWidth: 450,
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
        border: '1px solid #cbd5e1',
        boxSizing: 'border-box'
      }}
    >
      <div style={{
        textAlign: 'center',
        marginBottom: 32,
        paddingBottom: 24,
        borderBottom: '1px solid #f0f0f0'
      }}>
        <h2 style={{
          fontWeight: 700,
          fontSize: 18,
          margin: '0 0 2px 0',
          color: '#111827'
        }}>
          Riwayat Keuangan
        </h2>
        <p style={{ margin: 0, color: '#9ca3af', fontSize: 13 }}>
          {dataKeuangan.length} riwayat pengajuan diproses
        </p>
      </div>

      {renderCarousel('Daftar Pengajuan', dataKeuangan, '#3b82f6')}

    </motion.div>
  );
};

export default ListUangReadonly;
